import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Modal from 'antd/lib/modal/Modal';
import {
  Button,
} from 'components/gyramais';
import {
  termsOfUse,
  privacyPolicy,
} from 'utils';
import './styles.less';

const PolicyOrTermsModal = ({ type = 'terms', visible, onClose }) => (
  <Modal
    style={{ whiteSpace: 'pre-line' }}
    title={type === 'policy' ? 'Política de Privacidade' : 'Termos de Uso'}
    centered
    visible={visible}
    onCancel={onClose}
    footer={(
      <Button onClick={onClose}>
        Fechar
      </Button>
    )}
  >
    <div className="policy-or-terms-container">
      <p>
        {type === 'policy' ? privacyPolicy : termsOfUse}
      </p>
    </div>
  </Modal>
);

PolicyOrTermsModal.propTypes = {
  type: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
};

export default memo(PolicyOrTermsModal);
